export default "__VITE_ASSET__DtI0hpBm__"